import { render, staticRenderFns } from "./PageCreate.vue?vue&type=template&id=7955c8bb&scoped=true&"
import script from "./PageCreate.vue?vue&type=script&lang=js&"
export * from "./PageCreate.vue?vue&type=script&lang=js&"
import style0 from "./PageCreate.vue?vue&type=style&index=0&id=7955c8bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7955c8bb",
  null
  
)

export default component.exports